import {
  XA_FETCH_DOWNLOADINFO_POST,
  XA_FETCH_DOWNLOADINFO_SUCCESS,
  XA_FETCH_DOWNLOADINFO_FAILURE,
  XA_CHANGE_PLATFORM,
} from '../../actions/xAgent';

const INITIAL_STATE = {
  forPlatform: 'windows',
  download: {},
};

export default function xAgentDownloadReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case XA_FETCH_DOWNLOADINFO_SUCCESS:
      return {
        ...state,
        download: action.payload,
      };
    case XA_CHANGE_PLATFORM:
      return {
        ...state,
        forPlatform: action.toPlatform,
      };
    case XA_FETCH_DOWNLOADINFO_FAILURE:
    case XA_FETCH_DOWNLOADINFO_POST:
    default:
      return state;
  }
}
